import { useCallback, useEffect } from 'react';

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
} from '@components/ui/form';
import { Input } from '@components/ui/input';
import formatterDecimal from '@formatters/decimal';
import { useFormContext } from 'react-hook-form';
import { NumberFormatBase } from 'react-number-format';
import { z } from 'zod';

import { useHidratacaoQueimado } from '../context';
import type { formSchema } from '../formSchema';

function SCQCalculated() {
  const { setSCQ } = useHidratacaoQueimado();
  const form = useFormContext<z.infer<typeof formSchema>>();

  const handleChangePercentage = useCallback(
    (value: string): void => {
      const valueParsed = Number(value.replace(',', '.'));
      setSCQ(valueParsed);
    },
    [setSCQ],
  );

  useEffect(() => {
    const subscription = form.watch((value, { name }) => {
      if (name === 'percentage' && value.percentage) {
        handleChangePercentage(value.percentage);
      }
    });
    return () => subscription.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  return (
    <div className="flex flex-col items-center">
      <FormField
        control={form.control}
        name="percentage"
        render={({ field: { ref, ...rest } }) => (
          <FormItem className="flex flex-row items-center">
            <FormLabel>Superfície acometida:</FormLabel>
            <FormControl>
              <NumberFormatBase
                className="[&_input]:w-26 [&_input]:text-center"
                customInput={Input}
                format={(value) => formatterDecimal(value, 1)}
                getCaretBoundary={(formattedValue) => {
                  const boundaryAry = Array.from({
                    length: formattedValue.length + 1,
                  }).map(() => true);
                  boundaryAry[0] = false;
                  boundaryAry[1] = false;
                  boundaryAry[2] = false;
                  return boundaryAry;
                }}
                getInputRef={ref}
                {...rest}
              />
            </FormControl>
            <FormDescription className="text-lg">%</FormDescription>
          </FormItem>
        )}
      />
    </div>
  );
}
export default SCQCalculated;
